import "Data/ServerSource";
/** @namespace Accounting.Data */
NS("Accounting.Data");

/**
 * Accounting.Data.Types source
 * @class
 * @extends Data.ServerSource
 */
Accounting.Data.Kinds = Class(Data.ServerSource, /** @lends Accounting.Data.Kinds.prototype */ {
    url: "Accounting/Web/Kinds/",
    fields: [
        { name: "id", title: "id" }, // int
        { name: "name", title: "name" }, // string
        { name: "description", title: "description" }, // string

        { name: "createddatetime", title: "createddatetime" }, // string
        { name: "modifieddatetime", title: "modifieddatetime" }, // string
        { name: "creator", title: "creator" }, // json
        { name: "modifier", title: "modifier" }, // json
    ],

    findForMap(options, callback) {
        return this.call('findForMap', options, callback)
    }
});
